const BASE = '/spring/matrimony';

function redirectToMatrimonyLogin() {
  if (!window.location.pathname.endsWith('/login')) {
    window.location.href = '/app/matrimony/login';
  }
}

// Used only for protected endpoints — redirects to login on 401/403
async function req(path, options = {}) {
  const res = await fetch(`${BASE}${path}`, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
    ...options,
  });
  if (res.redirected && res.url.includes('login')) { redirectToMatrimonyLogin(); return null; }
  if (res.status === 401 || res.status === 403) { redirectToMatrimonyLogin(); return null; }
  let body;
  try { body = await res.json(); } catch {
    const ct = res.headers.get('content-type') || '';
    if (!res.ok && ct.includes('text/html')) { redirectToMatrimonyLogin(); return null; }
    body = null;
  }
  if (body && body.error === 'Not authenticated') { redirectToMatrimonyLogin(); return null; }
  if (!res.ok || (body && body.error)) {
    throw new Error((body && (body.message || body.error)) || `HTTP ${res.status}`);
  }
  return body;
}

// Silent fetch — never redirects, lets caller handle errors (used for getMe)
async function reqSilent(path, options = {}) {
  const res = await fetch(`${BASE}${path}`, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
    ...options,
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

export const matrimonyApi = {
  // Public — use reqSilent so a 401/error never triggers a redirect
  getProfiles: (params = {}) => {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== '') qs.set(k, v); });
    const q = qs.toString();
    return reqSilent(`/profiles${q ? `?${q}` : ''}`);
  },
  getProfile:  (id) => reqSilent(`/profiles/${id}`),
  getFilters:  ()   => reqSilent('/filters'),

  // File uploads (multipart — not JSON)
  uploadPhoto: (file) => {
    const form = new FormData();
    form.append('file', file);
    return fetch(`${BASE}/upload/photo`, { method: 'POST', credentials: 'include', body: form })
      .then(async res => {
        const body = await res.json().catch(() => null);
        if (!res.ok || (body && body.error)) throw new Error((body && body.error) || `HTTP ${res.status}`);
        return body;
      });
  },
  uploadHoroscope: (file) => {
    const form = new FormData();
    form.append('file', file);
    return fetch(`${BASE}/upload/horoscope`, { method: 'POST', credentials: 'include', body: form })
      .then(async res => {
        const body = await res.json().catch(() => null);
        if (!res.ok || (body && body.error)) throw new Error((body && body.error) || `HTTP ${res.status}`);
        return body;
      });
  },

  // Auth
  register:  (data) => req('/auth/register',  { method: 'POST', body: JSON.stringify(data) }),
  login:     (data) => req('/auth/login',     { method: 'POST', body: JSON.stringify(data) }),
  logout:    ()     => req('/auth/logout',    { method: 'POST' }),
  getMe:     ()     => reqSilent('/auth/me'),

  // User
  updateProfile:  (data) => req('/my/profile', { method: 'PUT', body: JSON.stringify(data) }),
  changePassword: (data) => req('/my/change-password', { method: 'PUT', body: JSON.stringify(data) }),

  // Admin
  adminStats:         ()           => req('/admin/stats'),
  adminUsers:         (status)     => req(`/admin/users${status ? `?status=${status}` : ''}`),
  adminSetStatus:     (id, status) => req(`/admin/users/${id}/status`, { method: 'PUT', body: JSON.stringify({ status }) }),
  adminProfiles:      (status)     => req(`/admin/profiles${status ? `?status=${status}` : ''}`),
  adminRemoveProfile:  (id)             => req(`/admin/profiles/${id}`, { method: 'DELETE' }),
  adminResetPassword:  (id, newPassword) => req(`/admin/users/${id}/reset-password`, { method: 'PUT', body: JSON.stringify({ newPassword }) }),
};
